import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Award() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            頑張るあなたを応援するデリオン賞
          </Typography>
          　北奥羽に住んでいる方で、地域貢献や将来期待される活動に取り組む人たちに幅広く光を当てエールを送るものです。<br />
          　デーリー東北賞５０周年を記念して２０２１年に創設しました。<br />
        </Box>


        <Box my={8}>
          <Typography className="font-weight-bold my-3 text-white bg-dark rounded px-3 py-1" variant="subtitle1" component="div">
            第５回「頑張るあなたを応援する　デリオン賞」受賞団体（2026年３月５日贈呈）
          </Typography>
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={4}>
                <img src="/images/award-delion/2026-001.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  市民の手で自主上映会　白マドの灯（あかり）＝八戸市、小倉学代表
                </Typography>
                　２０２３年３月に発足。メンバーは三八地域の２０～６０代の１８人。白マドはデザイン用語で「余白」を意味する。多様なスタイルの自主上映会が、映画館のない街の余白を埋める事業でありたいという思いを込めている。<br />
                【写真説明】<br />
                多彩なテーマで映画上映の活動に取り組む「白マドの灯」の小倉学代表（左）と広報の上平美紀さん<br />
                </Grid>
            </Grid>
          </Box>
          <Box my={4} textAlign="left">
            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={4}>
                <img src="/images/award-delion/2026-002.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  地元産鮮魚のブランド化推進　八戸水産価値向上実行委員会（シン八戸）＝石井駿吾会長
                </Typography>
                　八戸市の事業「八戸の鮮魚ブランディングプロジェクト」の実施主体。メンバーは２２人。八戸のまちづくり活動にも関わってきた佐藤容紹（ひろつぐ）氏と尾崎裕美氏が事務局を担う。２０２６年度以降の一般社団法人化を見据える。<br />
                【写真説明】<br />
                八戸港に水揚げされた鮮魚のブランド化に取り組む「シン八戸」のメンバー<br />
              </Grid>
            </Grid>
          </Box>
          <Box my={4} textAlign="left">
            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={4}>
                <img src="/images/award-delion/2026-003.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  町民の健康づくり支え40年　六戸町食生活改善推進員会＝瀬川妙子会長
                </Typography>
                　１９８６年に発足。活動当初から町民の健康意識を高めようと、減塩や野菜摂取などのＰＲを続けてきた。農林水産省が食育推進の優れた取り組みをたたえる「食育活動表彰」ボランティア部門食生活改善推進員の部で、２０２５年に最高位の農林水産大臣賞を受賞した。<br />
                【写真説明】<br />
                町民の健康意識の向上に向けて活動する六戸町食生活改善推進員会のメンバー<br />
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3 text-white bg-dark rounded px-3 py-3" variant="subtitle1" component="div">
            第５回「頑張るあなたを応援する　デリオン賞」贈呈式／受賞３団体　飛躍誓う（2026/03/06）
          </Typography>
          <img src="/images/award-delion/2025-top-min.jpg" className="float-img float-md-left mx-md-3 my-3" />
          　デーリー東北新聞社は５日、地域貢献や将来性が期待される人たちへエールを送る「第５回頑張るあなたを応援する　デリオン賞」の贈呈式を八戸市のデーリー東北ホールで開いた。受賞した３団体は喜びを胸に、さらなる飛躍を誓った。<br/>
          　受賞したのは映画上映会の主催や他団体が行う上映の支援を手がけるプロジェクト「白マドの灯（あかり）」（八戸市）、地元水産物の付加価値向上とブランド化に挑戦する八戸水産価値向上実行委員会（同市）、４０年にわたり減塩レシピの開発や食育活動に取り組み続ける六戸町食生活改善推進員会。<br/>
          　贈呈式で、デーリー東北新聞社の広瀬知明社長は「これからも地元に対する熱い思いと、飽くなきチャレンジ精神を持って活動を続け、明るいニュースを私たちに届けていただきたい」と激励した。<br/>
          　受賞者あいさつで、白マドの灯の小倉学代表は「映画は街に多様性を生み出し、人と人をつなげる力を持つ。その力を発揮するような上映会を地域で続けていく」と意欲を語った。<br/>
          　八戸水産価値向上実行委員会の石井駿吾会長は「八戸のおいしい魚に誇りを持ってブランド化し、漁師、鮮魚店、飲食店が一緒になって全国に広めていきたい」と力を込めた。<br/>
          　六戸町食生活改善推進員会の瀬川妙子会長は「受賞は会員の先輩方が苦労しながら長く続けた活動が評価された結果だと思う。大変喜ばしく、会員一同の励みになる」と感謝した。<br/>
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-oikawa-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  及川　晴香（おいかわ・はるか）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  １９８８年５月、八戸市生まれ。２０１１年、木村書店入社。１７年から、同店のオリジナルキャラクター「きむねこ」が登場するポップを製作。現在、本紙ヤング面で「木村書店ポプ担のあの本この本読んでやあんせ」を連載中。
                </div>
                　八戸市小中野８丁目に店を構え、９０年の歴史を持つ木村書店は近年、「ポップごと売る本屋さん」として、全国から注目を集めている。その立役者がポップ担当の及川さん。ツイッターアカウントでは、書籍の紹介と書店員の日常をつづった漫画を投稿しており、フォロワーは２万５千人超え。アナログとデジタルの両方の手法で、地方の小さな書店や本の魅力を全国に発信している。「ポプ担」の愛称で親しまれ、２０２１年には３年分のポップをまとめた「青森の八戸にある小さな本屋さんの猫がかわいいポップの本」を小学館から出版した。
              </Grid>
            </Grid>
          </Box>

          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-sekikawa-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  関川　愛音（せきかわ・めろでぃ）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  ２００７年７月生まれ。八戸市出身。市立湊小 湊中２年。ボルダリングのユース日本選手権の成績は、２０年にユースＣ（１２、１３歳）優勝、２１年は同Ｂ（１４、１５歳）で準優勝。来春からは市内の私立高校で競技を続ける予定。身長１６１センチ
                </div>
                　人工の壁面に設けられた「ホールド」と呼ばれる課題を手足などの力でクリアしていくスポーツクライミング。この競技の世代別（ユース）日本代表で、世界大会での活躍が期待されている。長い手足と体幹の強さを武器にジュニア世代の大会で常に好成績を収め、シニア顔負けの実力を誇る。１５歳になる今年からは、五輪代表選手選考につながる国内大会「ジャパンカップ」への参戦が可能になる。もちろん、２４年のパリ五輪も視界に入っており、「夢は五輪で金メダル」と志は高い。「この一年が勝負の年」。世界に羽ばたく日は近づいている。
              </Grid>
            </Grid>
          </Box>

          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award-delion/2022-neichi-min.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold mb-4" variant="h6" component="div">
                  根市　大樹（ねいち・ひろき）<br />
                </Typography>
                <div className="font-weight-bold mb-4">
                  １９８１年６月、南部町（旧名川町）生まれ。青森県立八戸高 大阪芸術大文芸学部卒。デーリー東北新聞社を退職後、２０１２年にＮＰＯ法人の立ち上げに参画。１６年、合同会社「南部どき」を設立。１８年、同町大向に同名のカフェを開店した。
                </div>
                　地元にあふれる資源に着目し、次々と地域活性化のためのアイデアを打ち出している合同会社「南部どき」（南部町）。魅力ある地域や子どもたちに誇れる〝ふるさと〟を残したいと日々、奔走している。代表の根市さんはオーストラリアへの農業留学などを経て、帰国後、地産地消をコンセプトにした飲食店を開店。シェフの弟が腕を振るうレストランは人気を呼び、農産物の新たな販路を生み出した。地元でのＮＰＯ法人立ち上げのほか、処分されてきた果樹の剪定（せんてい）枝を食品の薫製に活用したり、地元駅前にカフェを開店したりと、精力的に活動を続けている。
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            これまでの受賞者
          </Typography>
          <Box my={4} textAlign="left">

            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４回（令和６年度）</dt>
                  <dd>
                    吉田悠馬さん<br/>
                    本村春介さん<br/>
                    生産者団体「郷のきみの会」<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>

            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３回（令和５年度）</dt>
                  <dd>
                    沢上りんかさん<br/>
                    五十嵐孝直さん<br/>
                    八戸圏域山伏神楽再興委員会<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>

            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２回（令和４年度）</dt>
                  <dd>
                    地域おこし団体「サンノヘエール」<br/>
                    島守宏和さん<br/>
                    地域団体「ワカス湯田エリアス」<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>

            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１回（令和３年度）</dt>
                  <dd>
                    及川春香さん<br/>
                    関川愛音さん<br/>
                    合同会社「南部どき」<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>

          </Box>
        </Box>
      </div>
    </div>
  );
}

export default Award;
